import React from "react";
import { NavLink } from "react-router-dom";
import "../../style/brokenLinks.css";
import brokenImg from '../../assets/broken-image.png'

export default function BrokenLinks() {
  return (
    <div className="broken-links-page">
      <h1 className="page-title">
        Broken Links - Images
      </h1>

      {/* Broken Image Section */}
      <div className="link-section">
        <h5><strong>Broken image</strong></h5>
        <p>
          <img
            className="broken-img"
            src={brokenImg}
            alt="Broken"
          />
        </p>
      </div>

      {/* Valid Link Section */}
      <div className="link-section">
        <h5><strong>Valid Link</strong></h5>
        <p>
          <NavLink
            to="https://www.google.com/"
            target="_blank"
            rel="noreferrer"
            className="valid-link"
          >
            Click Here for Valid Link
          </NavLink>
        </p>
      </div>

      {/* Broken Link Section */}
      <div className="link-section">
        <h5><strong>Broken Link</strong></h5>
        <p>
          <NavLink
            to="/broken-link-status-code"
            className="broken-link"
          >
            Click Here for Broken Link
          </NavLink>
        </p>
      </div>
    </div>
  );
}